import React, { useEffect, useState } from "react";
import {
  createGeoUnit,
  existsGeoUnit,
  geoDropdownById,
  geoFieldsById,
} from "../../api/geoHierarchyApi";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import {
  getBulkDropdownData,
  getFieldValuesByTableAndId,
  getTextByValueAndKey,
} from "../../api/keyvalue";
import SearchDropdown from "../input/SearchDropdown";
import { countryName, countryStartsWith } from "../../api/countryApi";
import Button from "../input/Button";
import ButtonRenderer from "../renderer/ButtonRenderer";
import Grid from "../Grid";
import { ActiveCellStyle, StatusCellStyle } from "../renderer/StyleRenderer";
import { toast } from "react-toastify";
import { Plus } from "react-feather";
import useUserCompany from "../../hooks/useUserCompany";
import DeleteButtonRenderer from "../renderer/DeleteButtonRenderer";

const GeoManagerAddComponent = ({ selectedType, onClose }) => {
  const [formConfig, setFormConfig] = useState({
    gldId: null,
    geoUnitValue: "",
    lonLat: false,
    fields: [],
  });

  const [activeOptions, setActiveOptions] = useState([]);

  const [formData, setFormData] = useState({});
  const [geoList, setGeoList] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [country, setCountry] = useState(null);

  const [paramState, setParamState] = useState({});
  const [searchFieldReset, setSearchFieldReset] = useState(false);

  const [dynamicFieldData, setDynamicFieldData] = useState({});

  const user= localStorage.getItem("username");
  console.log("user", user);
  const initParamState = (fields, countryId = null) => {
    const state = { param1: countryId };
    fields.forEach((_, index) => {
      state[`param${index + 2}`] = null;
    });
    return state;
  };

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
      country: null,
      active: { value: 1, label: "Active" },
      ...formConfig.fields.reduce((acc, field) => {
        acc[field.name] = null;
        return acc;
      }, {}),
    });
    setParamState(initParamState(formConfig.fields));
    setEditingIndex(null);
    setSearchFieldReset(true);
    setDynamicFieldData({});
  };

  useEffect(() => {
    if (selectedType?.key) {
      geoFieldsById(selectedType.key)
        .then((data) => {
          setFormConfig({
            gldId: data.gldId,
            geoUnitValue: data.geoUnitValue,
            lonLat: data.lonLat,
            fields: data.fields || [],
          });
          setParamState(initParamState(data.fields));

          resetForm();
        })
        .catch(console.error);
    }
  }, [selectedType?.key]);

  useEffect(() => {
    (async () => {
      const { active, status } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
      ]);
      setActiveOptions(active);

      if (!formData.active) {
        setFormData((prev) => ({
          ...prev,
          active: { value: 1, label: "Active" },
        }));
      }
    })();
  }, []);

  const getDynamicFieldData = async () => {
    const dynamicData = {};
    // if(formConfig.fields && formConfig.fields?.length >0){
    //   formConfig.fields.forEach((field)=>{

    //   })
    // }
    for (let index = 0; index < formConfig.fields.length; index++) {
      const field = formConfig.fields[index];
      const fieldId = paramState[`param${index + 2}`];
      console.log("field", field);
      console.log("fieldId", fieldId);

      if (fieldId !== null && fieldId !== undefined) {
        try {
          const result = await getFieldValuesByTableAndId({
            tableName: field.tableName,
            primaryKey: field.primaryKey,
            fieldNames: field.fieldName,
            ids: fieldId.toString(),
          });

          dynamicData[field.name] = result[0]?.field1 || "";
        } catch (error) {
          console.error(`Error fetching data for ${field.name}:`, error);
          dynamicData[field.name] = "";
        }
      } else {
        dynamicData[field.name] = "";
      }
    }

    return dynamicData;
  };

  useEffect(() => {
    const updateDynamicData = async () => {};
    updateDynamicData();
  }, [paramState, formConfig.fields]);

  const handleResultSelect = (field, data, index) => {
    setFormData((prev) => ({ ...prev, [field.name]: data }));
    setParamState((prev) => {
      const newParams = { ...prev, [`param${index + 2}`]: data?.value || data };
      for (let i = index + 3; i <= formConfig.fields.length + 1; i++) {
        newParams[`param${i}`] = null;
      }
      return newParams;
    });
  };

  const handleClear = (field, index) => {
    setFormData((prev) => ({
      ...prev,
      [field.name]: null,
      [`${field.name}Id`]: null,
    }));
    setParamState((prev) => {
      const newParams = { ...prev, [`param${index + 2}`]: null };
      for (let i = index + 3; i <= formConfig.fields.length + 1; i++) {
        newParams[`param${i}`] = null;
      }
      return newParams;
    });
  };

  console.log("form config", formConfig);

  const handleAddClick = async () => {
    if (!formData.name || formData.name.trim() === "") {
      toast.error("Please Fill Name", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    if (!formData.country) {
      toast.error("Please Select Country", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    for (let f of formConfig.fields) {
      const fieldValue = formData[f.name] || formData[`${f.name}Id`];

      const isEmpty =
        !fieldValue ||
        fieldValue === "" ||
        (typeof fieldValue === "object" &&
          Object.keys(fieldValue).length === 0);

      if (isEmpty) {
        toast.error(`Please select ${f.name}`, {
          autoClose: 5000,
          containerId: "Main",
        });
        return;
      }
    }
    const countryData = formData.country;
    console.log("country data", countryData);

    let countryName = "";
    // if (countryData) {
    const getCountryName = await getFieldValuesByTableAndId({
      tableName: "masterdata.tms_m_reg_country",
      primaryKey: "cou_id",
      fieldNames: "cou_country",
      ids: paramState.param1,
    });
    countryName = getCountryName[0].field1;
    // }
    let currentFieldData = {};

    if (formConfig.fields.length > 0) {
      const currentParamState = { ...paramState };

      if (editingIndex !== null) {
        currentParamState.param1 = formData.country || paramState.param1;
        formConfig.fields.forEach((field, index) => {
          const fieldValue =
            formData[`${field.name}Id`] || formData[field.name];
          currentParamState[`param${index + 2}`] = fieldValue;
        });
      }

      const data = await getDynamicFieldData(currentParamState);
      setDynamicFieldData(data);
      currentFieldData = data;
      console.log("dynamic data", data);
    }
    const existsData = {
      name: formData.name,
      params: { ...paramState },
    };
    if (editingIndex === null) {
      const exists = await existsGeoUnit(formConfig.gldId, existsData);
      if (exists) {
        toast.error(`"${formData.name}" already exists`, {
          autoClose: 5000,
          containerId: "Main",
        });
        return;
      }
    }

    const record = {
      id: editingIndex !== null ? geoList[editingIndex].id : Date.now(),
      name: formData.name || "",
      description: formData.description || "",
      countryId: formData.country,
      countryName,
      ...formConfig.fields.reduce((acc, field) => {
        const val = formData[`${field.name}Id`] || formData[field.name];
        console.log("field val", field.name, val);
        acc[`${field.name}Id`] = val;
        acc[`${field.name}Name`] = currentFieldData[field.name] || "";
        return acc;
      }, {}),
      latitude: formConfig.lonLat ? formData.latitude || "" : null,
      longitude: formConfig.lonLat ? formData.longitude || "" : null,
      active: formData.active?.value,
      author:user,
      activeName: await getTextByValueAndKey("active", formData.active?.value),
      params:
        editingIndex !== null
          ? (() => {
              const newParams = {
                param1: formData.country || paramState.param1,
              };
              formConfig.fields.forEach((field, index) => {
                const fieldValue =
                  formData[`${field.name}Id`] || formData[field.name];
                newParams[`param${index + 2}`] = fieldValue;
              });
              return newParams;
            })()
          : { ...paramState },
    };
    console.log("add record", record);
    let updated;
    if (editingIndex !== null) {
      updated = [...geoList];
      updated[editingIndex] = record;
    } else {
      updated = [...geoList, record];
    }

    setGeoList(updated);
    resetForm();
  };

  console.log("form data", formData);
  console.log("form table", formConfig.fields.tableName);

  const handleDelete = (row) =>
    setGeoList((prev) => prev.filter((item) => item.id !== row.id));

  const handleEdit = (row) => {
    setFormData({
      ...row,
      name: row.name,
      description: row.description,
      countryName: row.countryName,
      country: row.countryId,
      active: row.active ? { value: row.active, label: row.activeName } : null,
      // ...formConfig.fields.reduce((acc, field) => {
      //   const id = row[`${field.name}Id`];
      //   const name = row[`${field.name}Name`];
      //   acc[field.name] = id
      //     ? { value: id, title: name, text: name, label: name }
      //     : null;
      //   return acc;
      // }, {}),
    });
    console.log("form data edit", formData);

    const newParamState = { param1: row.countryId };
    formConfig.fields.forEach((field, index) => {
      newParamState[`param${index + 2}`] = row[`${field.name}Id`] || null;
    });
    setParamState(newParamState);

    setEditingIndex(geoList.findIndex((item) => item.id === row.id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (geoList.length === 0) {
      console.log("No records to submit");
      toast.warn("No Records to submit", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }

    const payload = geoList.map((item) => ({
      name: item.name || "",
      description: item.description || "",
      active: item.active || 1,
      author:item.author,
      latitude: item.latitude ? Number(item.latitude) : null,
      longitude: item.longitude ? Number(item.longitude) : null,
      params: item.params || {},
    }));

    console.log("Submitting payload:", payload);

    try {
      const response = await createGeoUnit(formConfig.gldId, payload);
      resetForm();
      setGeoList([]);
      console.log("Payload:", payload);
      toast.success("Record submitted Successfully", {
        autoClose: 5000,
        containerId: "Main",
      });
    } catch (e) {
      console.error("Error submitting:", e);
    }
  };

  const gridConfig = [
    { headerName: "Name", field: "name" },
    { headerName: "Description", field: "description" },
    { headerName: "Country", field: "countryName" },
    ...formConfig.fields.map((field) => ({
      headerName: field.label,
      field: `${field.name}Name`,
    })),
    ...(formConfig.lonLat
      ? [
          { headerName: "Latitude", field: "latitude" },
          { headerName: "Longitude", field: "longitude" },
        ]
      : []),

    {
      headerName: "Active",
      field: "activeName",
      cellRenderer: ActiveCellStyle,
    },
    {
      headerName: "Edit",
      field: "edit",
      cellRenderer: ButtonRenderer,
      cellRendererParams: (params) => ({
        label: "Edit",
        clickHandler: () => handleEdit(params.data),
      }),
    },
    {
      headerName: "Delete",
      field: "delete",
      cellRenderer: DeleteButtonRenderer,
      cellRendererParams: (params) => ({
        label: "Delete",
        className: "ui red button",
        clickHandler: () => handleDelete(params.data),
      }),
    },
  ];

  console.log("formData", formData);

  return (
    <div>
      <form className="ui form">
        <div className="ui segment">
          <h4 className="ui dividing header">
            {editingIndex !== null ? "Edit" : "Add"} {formConfig.geoUnitValue}
          </h4>
          <div className="ui segment">
            <div className="two fields">
              <Input
                label="Name"
                placeholder="Name"
                value={formData.name || ""}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, name: e.target.value }))
                }
                required
              />
              <Input
                label="Description"
                placeholder="Description"
                value={formData.description || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
              />
            </div>

            <div className="two fields">
              <Dropdown
                label="Active"
                options={activeOptions}
                value={formData.active?.value}
                onChange={(e, data) =>
                  setFormData((prev) => ({
                    ...prev,
                    active: { value: data.value, label: data.text },
                  }))
                }
                required
              />

              <SearchDropdown
                label="Country"
                placeholder="Select Country"
                fieldInfo={{
                  tableName: "masterdata.tms_m_reg_country",
                  primaryKey: "cou_id",
                  fieldName: "cou_country",
                  id: paramState.param1,
                }}
                api={countryStartsWith}
                multiGrid={true}
                multiGridCurrentValue={formData.countryName}
                value={formData.countryId}
                onResultSelect={(data) => {
                  setFormData((prev) => ({ ...prev, country: data }));
                  setParamState((prev) => ({
                    ...initParamState(formConfig.fields, data),
                  }));
                }}
                onClear={() => {
                  setFormData((prev) => ({ ...prev, country: null }));
                  setParamState(initParamState(formConfig.fields));
                }}
                clearable
                reset={searchFieldReset}
                setReset={setSearchFieldReset}
                required={true}
              />
            </div>

            <div className="two fields">
              {formConfig.fields.map((field, index) => (
                <SearchDropdown
                  key={field.seq}
                  label={field.label}
                  placeholder={`Select ${field.label}`}
                  multiGrid={true}
                  multiGridCurrentValue={formData[`${field.name}Name`]}
                  fieldInfo={{
                    tableName: field.tableName,
                    primaryKey: field.primaryKey,
                    fieldName: field.fieldName,
                    id: paramState[`param${index + 2}`],
                  }}
                  api={geoDropdownById}
                  apiDependency={{ id: field.gldId, params: paramState }}
                  value={formData[`${field.name}Id`]}
                  onResultSelect={(data) =>
                    handleResultSelect(field, data, index)
                  }
                  onClear={() => handleClear(field, index)}
                  clearable
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  required={true}
                />
              ))}
            </div>
            {formConfig.lonLat && (
              <div className="two fields">
                <Input
                  label="Latitude"
                  type="number"
                  placeholder="Latitude"
                  value={formData.latitude}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      latitude: e.target.value,
                    }))
                  }
                />

                <Input
                  label="Longitude"
                  type="number"
                  placeholder="Longitude"
                  value={formData.longitude}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      longitude: e.target.value,
                    }));
                  }}
                />
              </div>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 5 }}>
            <Button
              onClick={handleAddClick}
              label={editingIndex !== null ? "Update" : "Add"}
              Icon={Plus}
            />
          </div>

          <div style={{ marginTop: 20 }}>
            <Grid
              heading={`${formConfig.geoUnitValue} Records`}
              config={gridConfig}
              content={geoList}
            />
          </div>
        </div>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "30px",
            }}
          >
            <Button template="submit" onClick={handleSubmit} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default GeoManagerAddComponent;
